<template>
  <div class="winner-page">
    <header class="winner-header">
      <img v-if="$i18n.locale === 'en'" src="../../static/images/winner/winners.png" :alt="$t('homeWinners')" />
      <h1 v-else>{{ $t('homeWinners') }}</h1>
    </header>

    <main class="winner-board" :aria-label="$t('winnerList')">
      <div class="winner-columns">
        <div><img src="../../static/images/winner/date.png" alt="" /><span>{{ $t('Date') }}</span></div>
        <div><img src="../../static/images/winner/phone.png" alt="" /><span>{{ $t('Phone') }}</span></div>
        <div><img src="../../static/images/winner/prize.png" alt="" /><span>{{ $t('Prize') }}</span></div>
      </div>
      <div class="winner-list-scroll">
        <div v-for="(item,index) in list" :key="index" class="winner-row">
          <span class="winner-date">{{ item.date }}</span>
          <span class="winner-phone">{{ item.mobile }}</span>
          <span class="winner-prize">{{ item.prize_name }}</span>
        </div>
        <p v-if="!list.length && !loadingMore" class="winner-empty">{{ $t('winnerEmpty') }}</p>
        <button v-if="isShow && list.length" class="winner-more" type="button" :disabled="loadingMore" @click="getMore">{{ $t('showMore') }}</button>
      </div>
    </main>

    <HomeTabBar active="winners" :available="availableBoxes" @select-box="goBoxes" />
  </div>
</template>

<script>
import HomeTabBar from '../components/HomeTabBar'

export default {
  name: 'WinnerList',
  components: {HomeTabBar},
  data() {
    return {
      list: [],
      page: 1,
      isShow: true,
      loadingMore: false,
      availableBoxes: false
    }
  },
  created() {
    this.getHome()
    this.getBoxStatus()
  },
  methods: {
    getHome() {
      this.loadingMore = true
      this.$api.post('/api/index/rank', {page: this.page}, r => {
        this.loadingMore = false
        this.$parent.returnCode(r, () => {
          const rows = Array.isArray(r.data) ? r.data : []
          this.list = this.list.concat(rows)
          this.isShow = rows.length === 10
        })
      })
    },
    getMore() {
      if (!this.isShow || this.loadingMore) return
      this.page++
      this.getHome()
    },
    getBoxStatus() {
      this.$api.post('/api/index/index', null, r => {
        if (Number(r.code) === 1 && r.data) {
          this.availableBoxes = Number(r.data.draw_num) > 0
        }
      })
    },
    goBoxes() {
      this.$router.push({path: '/'})
    }
  }
}
</script>

<style scoped>
.winner-page {
  width: 100%;
  max-width: 480px;
  height: 100vh;
  min-height: 0;
  margin: 0 auto;
  padding: 0.75rem 0 1.8rem;
  overflow: hidden;
  background: #080e36 url(../../static/images/winner/winner_list_bg.jpg) no-repeat center center;
  background-size: 100% 100%;
  color: #fff;
  font-family: Atom-sans;
}
.winner-header {
  height: 1.4rem;
  margin-top: 0.35rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.winner-header img {
  display: block;
  width: 3.75rem;
  height: auto;
}
.winner-header h1 {
  max-width: 90%;
  margin: 0;
  font-family: Atom-sans-bold;
  font-size: 0.55rem;
  line-height: 1.15;
  text-align: center;
  text-shadow: 0 0 0.25rem #8653ff;
}
.winner-board {
  width: 91.2%;
  max-width: 7rem;
  aspect-ratio: 1025 / 1672;
  max-height: calc(100vh - 4.5rem);
  margin: 0.1rem auto 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: url(../../static/images/winner/winner_bg.png) no-repeat center center;
  background-size: 100% 100%;
}
.winner-columns {
  flex: 0 0 0.96rem;
  display: grid;
  grid-template-columns: 31% 37% 32%;
  align-items: center;
  background: url(../../static/images/winner/title_bg.png) no-repeat center center;
  background-size: 100% 100%;
  font-family: Atom-sans-bold;
  font-size: 0.3rem;
  line-height: 1;
}
.winner-columns > div {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.06rem;
}
.winner-columns > div + div {border-left: 0.01rem solid rgba(255,255,255,.55);}
.winner-columns img {width: 0.3rem;height: 0.3rem;object-fit: contain;}
.winner-list-scroll {
  flex: 1;
  min-height: 0;
  margin: 0.22rem 0.08rem 0.03rem;
  padding: 0 0.28rem 0.2rem;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #3268ff transparent;
}
.winner-list-scroll::-webkit-scrollbar {width: 0.05rem;}
.winner-list-scroll::-webkit-scrollbar-thumb {border-radius: 0.05rem;background: #3268ff;}
.winner-row {
  width: 100%;
  min-height: 0.96rem;
  margin-bottom: 0.14rem;
  display: grid;
  grid-template-columns: 31% 37% 32%;
  align-items: center;
  background: url(../../static/images/winner/winner_info_bg.png) no-repeat center center;
  background-size: 100% 100%;
  font-size: 0.26rem;
  line-height: 1.16;
  text-align: center;
}
.winner-row span {min-width: 0;padding: 0.07rem 0.02rem;}
.winner-date,.winner-phone {white-space: nowrap;}
.winner-prize {color: #a9ff36;font-size: 0.28rem;overflow-wrap: anywhere;}
.winner-more {
  display: block;
  margin: 0.18rem auto 0;
  padding: 0.1rem 0.32rem;
  border: 0.02rem solid #4f73ff;
  border-radius: 1rem;
  background: #0e1957;
  color: #fff;
  font-family: Atom-sans;
  font-size: 0.25rem;
}
.winner-more:disabled {opacity: .6;}
.winner-empty {padding: 0.5rem 0.15rem;text-align: center;font-size: 0.28rem;}
@media (min-width: 481px) {
  .winner-page {box-shadow: 0 0 0 100vmax #0d123b;}
}
</style>



// WEBPACK FOOTER //
// src/page/winnerList.vue